// extracted by mini-css-extract-plugin
export var cardIcon = "_6v-4";
export var checkboxCard = "_6v-0";
export var checkboxCardSelected = "_6v-3";
export var disabled = "_6v-1";
export var outerBorder = "_6v-2";
export var spacerMedium = "_6v-7";
export var spacerSmall = "_6v-6";
export var spacerXsmall = "_6v-5";